var offerDetailManager = (function() {
    function init() {
        var offerPage =  $(".offer-page");
        if(offerPage.length === 0) return;
        var isLanding =  $(".offer-page .convenzioni").length;
        var navigationHeader = $(".nav-main");
        var offerSticky = offerPage.find('.offer-sticky');
        
        topBannerImageContainer = offerPage.find(".offer-box-compact-container");
        //BANNER IMAGES
        desktopBannerImage = offerPage.find(".offer-box-compact-container").data("desktop-banner");
        tabletBannerImage = offerPage.find(".offer-box-compact-container").data("tablet-banner");
        mobileBannerImage = offerPage.find(".offer-box-compact-container").data("mobile-banner");

        if (offerSticky.length){
            offerSticky.find(".sticky-buttons .offer-sticky-cta .btn.qr-button").on('click', function () {
                scrollToQuoteRequest(navigationHeader.height()+offerSticky.height(), $($(this).attr('href'), offerPage));
            })
        }

        $(document).ready(function () {
            handleBackgroundImages();
        })
        $(window).on("resize", function () {
            handleBackgroundImages();
        })

        offerPage.find('.offer-box-compact-container .offer-box-compact-container-left .offer-card.offer-card-compact').on('click', function (e) {
            const classesToCheck = ['offer_annotations_popover_link', 'info-icon-blue', 'favourite-icon-blue', 'favourite'];
            var targetClasses = e.target.classList;
            if (typeof targetClasses != "undefined" && targetClasses.length){
                var scrollTo = true;
                $.each(classesToCheck, function (index, element) {
                    if (targetClasses.contains(classesToCheck[index])){
                        scrollTo = false;
                        return false;
                    }
                });
                if (scrollTo){
                    offerSticky.removeClass('d-none');
                    const heightToRemove = offerSticky.height()+navigationHeader.height();
                    offerSticky.addClass('d-none');
                    scrollToQuoteRequest(heightToRemove, $($(this).attr('data-anchor'), offerPage));
                }
            }

        })
        var quoteRequest = offerPage.find('#car-detail-quote-request-collapse-container');
        var topCtaContainer =offerPage.find('.top-ctas');
        if (topCtaContainer.length){
            topCtaContainer.find(".qr-button").on('click', function () {
                scrollToQuoteRequest(navigationHeader.height()+offerSticky.height(), $($(this).attr('href'), offerPage));
            });

            if ($(window).width()>576) {
                var maxWidthCta = 0;
                var topCtas = topCtaContainer.find('a.btn');
                topCtas.each( function(){
                    if ($(this).width() > maxWidthCta) {
                        maxWidthCta = $(this).width()
                    }
                });
                topCtas.width(maxWidthCta);
            }
        }

        $(window).on('scroll', function() {
            if ($(this).scrollTop() > $(".new-slider-component", offerPage).outerHeight()) {
                navigationHeader.removeClass('shadow-lg')
                if (!isLanding){
                    offerSticky.removeClass('d-none');
                }
            } else {
                navigationHeader.addClass('shadow-lg')
                if (!isLanding){
                    offerSticky.addClass('d-none');
                }
            }
        });
        $(offerPage).find("a[href^='#car-detail-quote-request']").each(
            function() {
                $(this).bind("click", function() {
                    $('#car-detail-quote-request-collapse-container', offerPage).collapse("show")
                })
            }
        )
        $('#car-detail-quote-request-collapse-container', offerPage).on('show.bs.collapse', function (){
            var varNumber = $('[name=vat_number]').closest('.col-sm-6');
            if ($("select[name=customer_type]").val() === 'private') {
                $('[name=phone]').closest('.row').append(varNumber);
            } else {
                $('[name=company]').closest('.row').append(varNumber)
            }
        })

        function scrollToQuoteRequest(heightToRemove, customSection = null) {
            if (typeof heightToRemove != "undefined"){
                var sectionToReach = quoteRequest;
                if (typeof customSection != null && customSection.length>0) {
                    sectionToReach = customSection
                }
                $('html, body').stop().animate({
                    scrollTop: sectionToReach.offset().top - heightToRemove
                }, 1500);
            }
        }

        handleNotesAccordion(offerPage)
        trackAskQuoteClick();
    }

    function handleNotesAccordion(offerPage) {
        var noteRow = offerPage.find('.custom-dynamic-notes .note-row');
        if (noteRow.length){
            var moreText = noteRow.attr('data-more-text');
            var lessText = noteRow.attr('data-less-text');
            var noteContainer = noteRow.find('.note-container');
            var noteDescription = noteContainer.find('.description');
            var accordionExpanded = noteDescription.hasClass('expanded');
            var emissionContainer = noteRow.find('.emission-label-container');
            var showButton = offerPage.find('.custom-dynamic-notes .button-row .show-button');
            handleButton(showButton)
            showButton.on('click', function () {
                handleButton($(this));
            });

            function handleButton(button) {
                button.text(accordionExpanded? lessText : moreText)
                if (accordionExpanded){
                    noteDescription.addClass('expanded')
                    if (emissionContainer.length){
                        noteContainer.addClass('col-md-5')
                        noteContainer.removeClass('col-md-8')
                        emissionContainer.removeClass('d-none')
                    }
                    accordionExpanded = false
                }else {
                    noteDescription.removeClass('expanded')
                    if (emissionContainer.length){
                        emissionContainer.addClass('d-none')
                        noteContainer.removeClass('col-md-5')
                        noteContainer.addClass('col-md-8')
                    }
                    accordionExpanded = true
                }
            }

        }
    }

    function trackAskQuoteClick(){
        //click on card
        $(".offer-page .offer-card.offer-card-compact").on("click", function(){
            var vehicleClicked = $(this).find("p.offer-title").text().replace(/\s{2,}/g,' ').trim();
            manageGTM.trackAskQuoteClick(vehicleClicked);
        });

        //click on button inside card
        /*$(".offer-page .offer-card.offer-card-compact button").on("click", function(){
            var vehicleClicked = $(this).closest(".offer-card.offer-card-compact").find("p.offer-title").text().replace(/\s{2,}/g,' ').trim();
            manageGTM.trackAskQuoteClick(vehicleClicked);
        });*/

        //click on sticky and under slider buttons
        $(".offer-page .offer-sticky .offer-sticky-cta, .offer-page section.top-ctas").find("a.btn").not(".customizeOffer").not("[data-toggle]").on("click", function(){
            var vehicleClicked = $(this).closest(".offer-page").find(".offer-card.offer-card-compact p.offer-title").text().replace(/\s{2,}/g,' ').trim();
            manageGTM.trackAskQuoteClick(vehicleClicked);
        });
    }

    function handleBackgroundImages() {
        if($(window).width() >= 992){
            setTopBannerBackgroundImage(desktopBannerImage);
        }
        if($(window).width() < 992 && $(window).width() >= 576){
            setTopBannerBackgroundImage(tabletBannerImage);
        }
        if($(window).width() < 576){
            setTopBannerBackgroundImage(mobileBannerImage);
        }
    }

    function setTopBannerBackgroundImage(imageUrl){
        topBannerImageContainer.css("background-image", "url(" + imageUrl + ")")
    }

    return {
        init: init
    };
})(jQuery);